import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CircularProgress } from "@mui/material";
import { fDummyFunction, GridDataColumn } from "./Action";
import "./ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky";
const GCLocationwiseStock = ({
  xOpen = false,
  fCloseDetailModal,
  GridDataLocationwiseStockColumns,
  GridDataLocationwiseStockRows = [],
  xTitle = "Account Detail",
  xLabelItemName = "",
  xLabelBranch = "",
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  // Calculate sums
  let totalStkQty = 0;
  let totalStkVal = 0;
  let totalPRQty = 0;
  let totalSOQty = 0;
  let totalDOQty = 0;
  let totalSIQty = 0;
  let totalTRFQty = 0;
  let totalADJQty = 0;
  let totalReserved = 0;
  let totalAvlQty = 0;
  let totalLiveSales = 0;
  const modifiedData = GridDataLocationwiseStockRows.map((row) => {
    totalStkQty += row.StkQty || 0;
    totalStkVal += row.StkVal || 0;
    totalPRQty += row.PRQty || 0;
    totalSOQty += row.SOQty || 0;
    totalDOQty += row.DOQty || 0;
    totalSIQty += row.SIQty || 0;
    totalTRFQty += row.TRFQty || 0;
    totalADJQty += row.ADJQty || 0;
    totalReserved += row.Reserved || 0;
    totalAvlQty += row.AvlQty || 0;
    totalLiveSales += parseFloat(row.LiveSales) || 0;

    return {
      ...row,
    };
  });

  // // Add totals row
  const totalsRow = {
    id: modifiedData.length + 1,
    Location: "Total",
    StkQty: totalStkQty,
    StkVal: totalStkVal,
    SrNo: modifiedData.length + 1,
    Cost: "",
    ["LP.Rate"]: "",
    PRQty: totalPRQty,
    SOQty: totalSOQty,
    DOQty: totalDOQty,
    SIQty: totalSIQty,
    TRFQty: totalTRFQty,
    ADJQty: totalADJQty,
    Reserved: totalReserved,
    Loc: "",
    AvlQty: totalAvlQty,
    LiveSales: totalLiveSales,
    // assuming 'Cost' is a string
    // Add other properties if needed
  };

  modifiedData.length > 0 && modifiedData.push(totalsRow);

  return (
    <Modal
      open={xOpen}
      onClose={fCloseDetailModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        model-gc-search"
      >
          <GCTitleSticky
        title={xTitle}
        onClose={fCloseDetailModal}
        />
         

        <div className="p-2">
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className="mt-2 justify-content-between"
          >
            <Grid item xs={3} sm={1} md={1} className="gnr-item-search-label ">
              ItemName
            </Grid>
            <Grid
              item
              xs={8}
              sm={11}
              md={11}
              className="gnr-item-search-label "
            >
              {xLabelItemName}
            </Grid>
            <Grid item xs={3} sm={1} md={1} className="gnr-item-search-label ">
              Branch
            </Grid>
            <Grid
              item
              xs={8}
              sm={11}
              md={11}
              className="gnr-item-search-label "
            >
              {xLabelBranch}
            </Grid>
          </Grid>
          {false ? (
            <div className="text-center">
              <CircularProgress />
            </div>
          ) : (
            <Grid container spacing={1} className="search-item ">
              <Grid
                item
                xs={12}
                className=" height-table-scroll"
                component="div"
              >
                <div
                  style={{
                    height: vMediaQuery ? "52vh" : "54vh",
                    width: "100%",
                  }}
                  id="table-main-grid-3"
                  className="search-grid-table mt-2"
                >
                  <Box style={{ height: "100%", width: "100%" }}>
                    <DataGrid
                      rowHeight={30}
                      headerHeight={40}
                      // getRowClassName={(params) =>
                      //   params.indexRelativeToCurrentPage % 2 === 0
                      //     ? "mui-even-row"
                      //     : "mui-odd-row"

                      // }
                      getRowClassName={(params) =>
                        `${
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? "mui-even-row"
                            : "mui-odd-row"
                        } ${
                          params.id === modifiedData.length
                            ? "mui-last-row"
                            : ""
                        }`
                      }
                      sx={{
                        border: 1,
                        borderColor: "primary.light",
                      }}
                      // rows={GridDataLocationwiseStockRows}
                      rows={modifiedData}
                      columns={
                        !!GridDataLocationwiseStockColumns
                          ? GridDataLocationwiseStockColumns
                          : GridDataColumn
                      }
                      // getRowId={(row) => row.id}
                      hideFooter={GridDataLocationwiseStockRows.length < 100}
                      components={{
                        Toolbar: GridToolbar,
                      }}
                    />
                  </Box>
                </div>
              </Grid>
            </Grid>
          )}
          {/* <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className="mt-2 "
          >
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              Stk.Qty ={totalStkQty}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              Stk.Val ={totalStkVal}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              Stk.PRQty ={totalPRQty}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              SO.SOQty ={totalSOQty}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              DO.Qty ={totalDOQty}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              SI.Qty ={totalSIQty}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              TFR.Qty ={totalTRFQty}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              Adj.Qty ={totalADJQty}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              Reserved ={totalReserved}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              Avl.Qty ={totalAvlQty}
            </Grid>
            <Grid
              item
              xs={3}
              sm={"auto"}
              md={"auto"}
              className="gnr-item-search-label "
            >
              LiveSales ={totalLiveSales}
            </Grid>
          </Grid> */}
        </div>
      </Box>
    </Modal>
  );
};

export default GCLocationwiseStock;
